import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-02/task-01";

const task: Slide = {
  title: "Task about spatial variations of pressure and particle velocity.",
  descriptionHtml:
    "Connect with lines. Note that multiple answers are expected in both cases and that answers are not exclusive.",
  layout: {
    type: "table",
    options: {
      cols: 3,
      rows: 2,
      colSpan: {
        "1:0": 3,
      },
      rowsSize: [1, 6],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "The spatial variations of",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    lineHeight: "22px",
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                    fontSize: "14px",
                  },
                },
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "are proportional To / depend on",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    lineHeight: "22px",
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                    fontSize: "14px",
                    textAlign: "center",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
